import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Sparkle } from '@phosphor-icons/react'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass, nodeTone } from '../../nodeCatalog'

const TYPE = 'sendEmail'
const Icon = nodeIcon(TYPE)

const SendEmailNode: React.FC<NodeProps> = ({ data, selected }) => {
  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle
        type="target"
        position={Position.Top}
        className={nodeHandleClass(TYPE)}
      />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Send Email</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Email Step'}</p>
        </div>
      </div>
      {data.subject && (
        <p className="mt-2 text-xs text-muted-foreground truncate pl-10">
          Subject: {data.subject}
        </p>
      )}
      {data.ai_config?.generation_mode === 'ai' && (
        <div className="mt-2 flex items-center gap-1 pl-10">
          <Sparkle className={`w-3 h-3 ${nodeTextClass(TYPE)}`} />
          <span className={`text-[10px] font-medium ${nodeTextClass(TYPE)}`}>AI Generated</span>
        </div>
      )}
      {data._upstreamEnrichmentFields?.length > 0 && (
        // Provenance badge: this data came from an upstream Enrich Contacts node,
        // so it carries that node type's tone rather than this card's.
        <div className="mt-1.5 flex items-center gap-1 pl-10">
          <div className={`w-2 h-2 rounded-full animate-pulse ${nodeTone('enrichContacts').solid}`} />
          <span className={`text-[10px] font-medium ${nodeTextClass('enrichContacts')}`}>
            {data._upstreamEnrichmentFields.length} enrichment fields
          </span>
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        className={nodeHandleClass(TYPE)}
      />
    </div>
  )
}

export default memo(SendEmailNode)
